class RoomScheduleViewController extends BaseTableViewController
{
    static newInstance() : RoomScheduleViewController {
        let vc = new RoomScheduleViewController("room-schedule-view");
        vc.initWithResource("layout/rooms/RoomScheduleView.html");
        return vc;
    }
}